/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styled from 'styled-components';
import useChart from '../../../../../screens/Analysis/sca-dds-kyc-widgets/assessment-performance/chart';

const Style = styled.div`
  .chart-c {
    height: 210px;
    width: calc(100% - 48px);
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }
`

const AssessmentTrend = ({ t, data: allData = {} }) => {
  const { container } = useChart({ data: allData, t });

  return (
    <Style>
      <div ref={container} className="chart-c" />
    </Style>
  );
};

export default AssessmentTrend;
